import { organizationApi, userApi } from '@app/services';

export default {
  namespaced: true,
  state: {
    id: null,
    loading: false,
    personal: null,
    organization: {
      form: {
        address: null,
        city: null,
        info: null,
        logo: null,
        phones: null,
        slug: null,
        website: null,
        worktime: null,
        inn: null,
        kpp: null,
        ogrn: null,
        okato: null,
        timezone: null,
        title: null,
        id: null,
        front: null,
      }
    },
    roles: []
  },
  mutations: {
    setUuid(state, payload) {
      state.id = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setPersonal(state, payload) {
      state.personal = { ...state.personal, ...payload };
    },
    setOrganization(state, payload) {
      state.organization.form = { ...state.organization.form, ...payload };
    },
    setFront(state, payload) {
      state.organization.form.front = payload;
    },
    setRoles(state, payload) {
      state.roles = payload;
    }
  },
  actions: {
    async loadOrganization({ commit }) {
      const organization = await organizationApi.get();
      commit('setOrganization', organization);
    },
    async loadPersonal({ commit, rootState }) {
      const personal = await userApi.getProfile(rootState.permission.userId);
      commit('setPersonal', personal);
    },
    async saveAvatar({ commit, rootState }, avatar) {
      await userApi.updateAvatar(rootState.permission.userId, avatar);
      commit('setPersonal', { avatar });
    },
    async savePersonal({ commit, rootState }, personal) {
      commit('setLoading', true);
      try {
        await userApi.update(rootState.permission.userId, personal);
        commit('setPersonal', personal);
      } catch (e) {
        console.error(e);
      }
      commit('setLoading', false);
    },
    async saveLogo({ commit }, logo) {
      await organizationApi.update({ logo });
      commit('setOrganization', { logo });
    },
    async saveOrganization({ commit }, organization) {
      commit('setLoading', true);
      try {
        await organizationApi.update(organization);
        commit('setOrganization', { ...organization });
      } catch (e) {
        console.error(e);
      }
      commit('setLoading', false);
    },
    async preload({ dispatch }, name) {
      switch (name) {
        case 'clinic.public':
        case 'personal-area.clinic':
          await dispatch('loadOrganization');
          break;
        case 'personal-area.personal':
          await dispatch('loadPersonal');
          break;
        case 'personal-area.main':
          await dispatch('loadOrganization');
          break;
        default:
          break;
      }
    }
  }
};
